/*
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-19 15:33:12
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-04-10 09:50:04
 */
import Vue from 'vue'
import VueI18n from 'vue-i18n'

// 引入各个语言配置文件
import zh from './zh'
import en from './en'

Vue.use(VueI18n)
let language = 'zh'
if (location.origin === process.env.VUE_APP_HOST_EN) {
  language = 'en'
}
// 创建vue-i18n实例i18n
const i18n = new VueI18n({
  // 设置默认语言
  locale: language, // 语言标识，默认中文
  // 添加多语言（每一个语言标示对应一个语言文件）
  messages: {
    zh,
    en
  }
})
// 暴露i18n
export default i18n
